/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, EventEmitter, Input, Output} from '@angular/core';

import template from './budget-view.component.html';

@Component({
  standalone: false,
  selector: 'adn-budget-view',
  template
})
export class BudgetViewComponent {
  @Input() uiBudgets: any[] = [];
  @Input() budgetRollover = false;
  @Input() budgetResult: any;
  @Input() isNew = false;
  @Output() editBudgets = new EventEmitter<void>();

  onEditBudgets(): void {
    this.editBudgets.emit();
  }
}
